import { Media, RepairOrderVideo } from 'app/SchedulerDashboard/types';
import { combineReducers } from 'redux';
import auth from 'redux/reducers/auth';
import customizer from 'redux/reducers/customizer';
import dashboard from 'redux/reducers/dashboard';
import navbar from 'redux/reducers/navbar/Index';
import scheduler from 'redux/reducers/scheduler/index';

interface DashboardInitialState {
  conditions: any[];
  coupons: any[];
  error: null | any; // error object
  gettingRO: boolean; // can be used to indicate when the app is fetching latest data
  loading: boolean; // shows fullscreen loader and prevents user interaction
  paymentFormLoaded: boolean;
  payments: any[];
  payment: null | any;
  repairOrder: null | any;
  repairOrderQuote: null | any;
  reviewSites: any[]; // if this has length and a rating has been submitted, show this list
  ros: any[]; // used for showing a customer's RO history
  settings: null | any; // app settings - note that all values are strings, including numbers and booleans
  trims: any[];
  videos: RepairOrderVideo[];
  mpiMedia: Media[];

  // Demo
  demo: null | any;

  // Rewards
  customerRewardsTier: any;
  rewardsTiers: any[];

  // Status
  mpiAvailable: boolean;
  paymentAvailable: boolean;
  paymentPaid: boolean;
  quoteAvailable: boolean;
  quoteSubmitted: boolean;
  videoAvailable: boolean;
  viewedMpi: boolean;
  viewedUVEye: boolean;
  viewedQuote: boolean;
  viewedVideo: boolean;
  visitAuthorized: boolean;

  isMpiVisible: boolean;
  isQuoteVisible: boolean;
  visibleVideoId: ''; // ID of video showing in modal

  appraisalRequested: boolean; // show the request appraisal card and allow request to be submitted
  financeRequested: boolean; // show the request finance card and allow request to be submitted

  // Waiver
  waiverVerbiage: null | any; // waiver text is stamped onto RO *at time of acknowledgement* or something like that
  waiverActivateAuthMessage: boolean; // boolean bypasses waiver card (via Settings)

  invalidQuoteETagMessage: null | any; // if current client has an out-of-date RO and has submitted a POST/PUT request, this will populate with the message to display
}

const rootReducer = combineReducers({
  customizer,
  auth,
  navbar,
  dashboard,
  scheduler,
});

export interface RootState {
  dashboard: DashboardInitialState;
}

export default rootReducer;
